import { goStorageAgent } from 'src/api/goStorageAgent';
import { throwApiError } from 'src/api/utils';

import type { GoStorageObject } from '../user-preference/UserPreference.api';

export type TAlertsGeneralSettingsData = {
  settings: {
    saveToJournal: boolean;
  };
  version?: number;
};

export type TAlertsGeneralSettingsDataRecord = GoStorageObject<TAlertsGeneralSettingsData>;

export function getDefaultAlertsGeneralSettings(): TAlertsGeneralSettingsData {
  return {
    settings: {
      saveToJournal: false,
    },
    version: 1,
  };
}

export class AlertsGeneralSettingsApi {
  constructor() {}

  async loadPreferences(): Promise<TAlertsGeneralSettingsDataRecord[]> {
    try {
      const { data } = await goStorageAgent.get<TAlertsGeneralSettingsDataRecord[]>(
        'object/list/GOdashboard_AlertsGeneralSettings',
      );

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }

  async updatePreferences(
    id: number,
    settings: TAlertsGeneralSettingsData,
    abortController?: AbortController,
  ): Promise<void> {
    try {
      await goStorageAgent.patch(`object/GOdashboard_AlertsGeneralSettings/${id}`, settings, {
        signal: abortController?.signal,
      });
    } catch (error) {
      throwApiError(error);
    }
  }

  async createPreferences(settings: TAlertsGeneralSettingsData): Promise<TAlertsGeneralSettingsDataRecord> {
    try {
      const { data } = await goStorageAgent.post('object/new/GOdashboard_AlertsGeneralSettings', settings);

      return data;
    } catch (error) {
      throwApiError(error);
    }
  }
}
